import React from 'react';
import { Link } from 'react-router-dom';
import './LHybridAcademy.css';

function LHybridAcademy() {
  return (
    <section className="features-section" id="features">
      <div className="lp-container">
        <h2 className="section-title">
          No es solo una IA. Es una 
          <span className="highlight-accent">Academia Hibrida</span>
        </h2>
        <div className="features-grid">
          {/* Esta tarjeta prometía clases con profesor y no llevaba a ninguna
              parte: la vitrina existía y no la enlazaba nadie, así que sólo
              llegaba quien supiera escribir la dirección. Una promesa sin
              puerta es peor que no hacer la promesa. */}
          <Link to="/profesores" className="feature-card lp-card-link">
            <div className="feature-icon">👩‍🏫</div>
            <h3 className="feature-title">Profesores</h3>
            <p className="feature-description">
              Clases One to One con profesores certificados por Cambridge.
            </p>
            <span className="lp-card-cta">Ver los profesores →</span>
          </Link>

          <div className="feature-card">
            <div className="feature-icon">👨‍👩‍👧‍👦</div>
            {/* 🩹 CIRUGÍA: Reubicación de badge */}
            <span className="feature-badge">🔥 PREMIUM</span>
            <h3 className="feature-title">Clases Grupales en Linea</h3>
            <p className="feature-description">
              Practica con compañeros de tu mismo nivel 
 en grupos reducidos de máximo 6 estudiantes.
            </p>
          </div>

          <div className="feature-card">
            <div className="feature-icon">🎯</div>
            {/* 🩹 CIRUGÍA: Reubicación de badge */}
            <span className="feature-badge">🔥 TUTOR PRO</span>
            <h3 className="feature-title">Secciones 1-a-1</h3>
            <p className="feature-description">
              Atencion personalizada con tu profesor dedicado. 
              Acelera tu fluidez con un plan hecho para ti.
            </p>
          </div>

          <div className="feature-card">
            <div className="feature-icon">🗺️</div>
            {/* 🩹 CIRUGÍA: Reubicación de badge */}
            <span className="feature-badge">🔥 PREMIUM</span>
            <h3 className="feature-title">Ruta de Fluidez (MCERL)</h3>
            <p className="feature-description">
              Sistema estructurado de A1 a C2. Sigue tu progreso 
              con el estandar europeo reconocido mundialmente.
            </p>
          </div>

          <div className="feature-card">
            <div className="feature-icon">🏆</div>
            <h3 className="feature-title">Gamificacion</h3>
            <p className="feature-description">
              Sistema de logros, puntos y desafios diarios que mantienen tu motivacion al maximo. Compite contigo mismo y celebra cada victoria.
            </p>
          </div>

          <div className="feature-card">
            <div className="feature-icon">🎮</div>
            <h3 className="feature-title">Mini Games</h3>
            <p className="feature-description">
              Juegos interactivos disenados para practicar vocabulario y gramatica sin aburrimiento. Aprende jugando y refuerza lo aprendido.
            </p>
          </div>
        </div>
      </div>
    </section>
  );
}

export default LHybridAcademy;